import { motion } from "framer-motion";
import { ShieldCheck, BadgeCheck, Lock, Handshake } from "lucide-react";

const ITEMS = [
  {
    icon: ShieldCheck,
    title: "Rien ne part sans vous",
    desc: "Aucun contenu n'est publié sans votre validation, en un clic.",
  },
  {
    icon: BadgeCheck,
    title: "IA identifiée",
    desc: "Les contenus générés par IA sont identifiés comme tels, sans ambiguïté.",
  },
  {
    icon: Lock,
    title: "Données cloisonnées",
    desc: "Vos données sont isolées par client, conformément au RGPD.",
  },
  {
    icon: Handshake,
    title: "Engagement concret",
    desc: "On s'engage sur des actions concrètes, pas sur des promesses floues.",
  },
];

export const EngagementsSection = () => (
  <section id="engagements" className="relative py-24 sm:py-32 scroll-mt-20">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-2xl"
      >
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-viol-soft mb-4">03 — Nos engagements</p>
        <h2 className="font-display font-bold text-3xl sm:text-5xl text-white leading-tight">
          Ce à quoi vous pouvez nous tenir.
        </h2>
      </motion.div>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {ITEMS.map((item, i) => {
          const Icon = item.icon;
          return (
            <motion.div
              key={item.title}
              data-testid={`engagement-card-${i}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="h-full rounded-2xl border border-ink-line bg-ink-surface/60 p-6 transition-all duration-300 hover:border-viol/40 hover:-translate-y-1"
            >
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-viol/10 border border-viol/25 text-viol-soft">
                <Icon size={20} />
              </span>
              <h3 className="mt-5 font-display font-bold text-lg text-white">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-mist">{item.desc}</p>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);

export default EngagementsSection;
